// @flow

import * as React from 'react';
import { Button } from '../../common/components/core';

type Props = {
  headerTitle?: string,
  headerSubtitle?: string,
  message?: string,
  buttonTitle?: string,
  imageURL?: string,
  errorMessage?: string,
  showError?: boolean,
  onActionClick: () => void
};

class EmailVerificationStatusLayout extends React.Component<Props> {
  render() {
    return (
      <div>
        <div data-testid="verify-email--header-title">
          <h1 className="verify-email">{this.props.headerTitle}</h1>
        </div>
        <div data-testid="verify-email--header-image">
          <img className="accept-image" src={this.props.imageURL} />
        </div>
        <h4 className="check-email">{this.props.headerSubtitle}</h4>
        <p className="email-instructions">{this.props.message}</p>
        <br />
        <br />
        <br />
        <div>
          <Button
            className="btn-email-verify-continue"
            onClick={this.props.onActionClick}
            testid="verify-email__continue"
          >
            {this.props.buttonTitle}
          </Button>
        </div>
        {this.props.showError ? (
          <div className="email-footer">
            <p className="email-warning">{this.props.errorMessage}</p>
          </div>
        ) : (
          <div className="email-footer"></div>
        )}
      </div>
    );
  }
}

export default EmailVerificationStatusLayout;
